import Vue from 'vue'
import wpLinkResolver from '@/wp-link-resolver'

export function linkResolver (href) {
  return wpLinkResolver(href)
}

export function isRelLink (url) {
  if (!url) console.warn('Missing param: url')
  return url && url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0
}

export function isExtLink (url) {
  let wpBase = process.env.VUE_APP_WP_BASE_URL
  if (!wpBase) console.warn('Missing .env variable: VUE_APP_WP_BASE_URL')
  if (isRelLink(url)) return false
  url = new URL(url)
  wpBase = new URL(wpBase)
  const bmsNamespace = ['www.bluemountain.school', 'bluemountain.school'].includes(url.host)
  return url.host !== wpBase.host && !bmsNamespace
}

export function resolveAllLinks (str) {
  // Finds all href and runs the linkResolver on them
  const regex = /href\s*=\s*(['"])(https?:\/\/.+?)\1/ig
  const start = str
  let link

  while ((link = regex.exec(start)) !== null) {
    str = str.replace(link[2], linkResolver(link[2]))
  }
  return str
}

export function canObserve () {
  return typeof window.IntersectionObserver === 'function'
}

export function optimImgSize (length) {
  const sizes = Vue.config.imgs.sizes // [320, 480, ...]
  const dpx = Vue.config.imgs.dpx
  length = parseInt(length * dpx * 0.95) // less density optically ok ?
  // find optimal
  const optimal = sizes.find(sz => length <= sz)
  // use optimal otherwise largest src
  return optimal || sizes[sizes.length - 1]
}

export function thumbSrc (src, length, byHeight = false, format) {
  const isShopify = src.includes('shopify.com')
  if (isShopify) return src
  //
  const baseUrl = Vue.config.imgs.baseUrl
  let size = optimImgSize(length)
  // resize by w/h
  size = byHeight ? 'h_' + size : 'w_' + size
  format = format ? `,_${format}` : ''
  return `${baseUrl}/image/fetch/q_60,${size}${format}/${src}`
}

export function toggleItem (i, arr) {
  // add
  if (!arr.includes(i)) return arr.push(i)
  // remove
  const pos = arr.indexOf(i)
  arr.splice(pos, 1)
}

export function toggleiOSVideoFull (video, mode) {
  const supports = video.webkitSupportsPresentationMode && video.webkitSupportsPresentationMode('fullscreen')
  if (!supports) return false
  mode = mode || (video.webkitPresentationMode === 'fullscreen' ? 'inline' : 'fullscreen')
  video.webkitSetPresentationMode(mode)
  return true
}

export function plainTitle (post) {
  if (!post) return null
  const el = document.createElement('div')
  el.innerHTML = post.title && post.title.rendered
  return el.innerText
}

export const variantId = graphqlId => atob(graphqlId).split('/').pop()
